import { handleApi } from "./api";
import { definedRouteTypes, definedApiMethods } from ".";

// const postMaintenance = async (body) => {
//   const url = `${ApiGateWayEndPoint}/${definedRouteTypes.maintenances}`;
//   const resp = await handleApi(url, definedApiMethods.post, { form: body });
//   return resp;
// };

const postLegacyMaintenance = async (body) => {
  const url = `${process.env.REACT_APP_LEGACY_GATEWAY}/${definedRouteTypes.maintenances}`;
  const resp = await handleApi(url, definedApiMethods.post, { form: body });
  return resp;
};

export default postLegacyMaintenance;
